'use client';

import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../store';

// FAANG-GRADE: Import the new layout components
import { AnonymousMarketplaceLayout } from './layouts/AnonymousMarketplaceLayout';
import { CustomerLayout } from './layouts/CustomerLayout';
import { PartnerAdminLayout } from './layouts/PartnerAdminLayout';
import { SuperAdminLayout } from './layouts/SuperAdminLayout';

interface LayoutRouterProps {
  children?: React.ReactNode;
  catalogBranding?: {
    name?: string;
    logo?: string;
    primaryColor?: string;
    website?: string;
    headerText?: string;
  };
}

const LayoutRouter: React.FC<LayoutRouterProps> = ({ children, catalogBranding }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  // Determine role with fallback logic (matches original Layout.tsx)
  let role = (user as any)?.role;

  // If Redux doesn't have user yet, try localStorage
  if (!role && typeof window !== 'undefined') {
    try {
      const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
      role = (storedUser as any)?.role || 'customer';
    } catch {}
  }

  role = role || 'customer';

  console.log(`[LAYOUT][ROUTER] Layout rendered for role: ${role}, authenticated: ${!!user}`);

  // FAANG-GRADE: Simple router that delegates to appropriate layout component
  if (!user) {
    // Anonymous users get marketplace browsing experience
    return <AnonymousMarketplaceLayout catalogBranding={catalogBranding}>{children}</AnonymousMarketplaceLayout>;
  }

  // Authenticated users get role-specific layouts
  switch (role) {
    case 'customer':
      return <CustomerLayout catalogBranding={catalogBranding}>{children}</CustomerLayout>;

    case 'partner_admin':
      return <PartnerAdminLayout>{children}</PartnerAdminLayout>;

    case 'partner_staff':
      // Partner staff use same layout as partner admin for now
      return <PartnerAdminLayout>{children}</PartnerAdminLayout>;

    case 'admin':
    case 'super_admin':
      return <SuperAdminLayout>{children}</SuperAdminLayout>;

    default:
      // Fallback to customer layout for unknown roles
      console.warn(`[LAYOUT][ROUTER] Unknown role "${role}", falling back to customer layout`);
      return <CustomerLayout>{children}</CustomerLayout>;
  }
};

export default LayoutRouter;